import { RequestConfig } from '@/interface'
import homeConfig from './home'
import adminConfig from './admin'
import commonConfig from './common'
import rpaConfig from './rpa'

const requestConfig: RequestConfig = {
  ...homeConfig,
  ...adminConfig,
  ...commonConfig,
  ...rpaConfig
}
export default requestConfig
